import { lazy, Route } from '@tanstack/router'

import { sponsorsRoute } from '.'

const Sponsors = lazy(() => import('../../pages/sponsors/sponsors'))

export const sponsorsListRoute = new Route({
  getParentRoute: () => sponsorsRoute,
  path: '/',
  component: Sponsors,
})
